import _ from 'lodash';

import { usePendingWritesTabQuery } from 'generated/graphql';

import { DateTime } from 'luxon';
import { routeDirectory } from 'modules';
import { useMemo } from 'react';
import * as types from './types';



export interface IPendingOrder {
  id: string;
  orderNumber: string;
  orderDate: DateTime;

  allProductsInNetSuite: boolean;
  storeHasDepartment: boolean;
  storeHasLocation: boolean;
  storeHasTaxItem: boolean;
  hasShippingService: boolean;
  hasMappedPaymentMethod: boolean;
  customerInNetSuite: boolean;
  orderNotInNetSuite: boolean;
  writeRequestGenerated: boolean;
  discountItemsSynced: boolean;
  urlToOrder: string;
}

export interface IData {
  pendingOrders: IPendingOrder[];
}

export function useQuery(filter: types.IFilter) {
  const queryTuple = usePendingWritesTabQuery({
    variables: {
      filter: {
        omniFreeText: filter.omniFreeText,
        storeId: filter.store?.id
      }
    }
  });

  const data = useMemo(
    (): IData => {
      const pendingOrders = queryTuple.data?.eligibleOrdersNotInNetSuite.nodes.map((node): IPendingOrder => ({
        id: node.id,
        urlToOrder: routeDirectory.partner.storeDetail.path(node.order.store.id, node.order.id),
        orderNumber: node.order.orderNumber,
        orderDate: DateTime.fromISO(node.order.orderDate),
        allProductsInNetSuite: _.find(node.criteria, c => c.code === 'allProductsInNetSuite')?.status === 'complete',
        storeHasDepartment: _.find(node.criteria, c => c.code === 'storeHasDepartment')?.status === 'complete',
        storeHasLocation: _.find(node.criteria, c => c.code === 'storeHasLocation')?.status === 'complete',
        storeHasTaxItem: _.find(node.criteria, c => c.code === 'storeHasTaxItem')?.status === 'complete',
        hasShippingService: _.find(node.criteria, c => c.code === 'hasShippingService')?.status === 'complete',
        hasMappedPaymentMethod: _.find(node.criteria, c => c.code === 'hasMappedPaymentMethod')?.status === 'complete',
        customerInNetSuite: _.find(node.criteria, c => c.code === 'customerInNetSuite')?.status === 'complete',
        orderNotInNetSuite: _.find(node.criteria, c => c.code === 'orderNotInNetSuite')?.status === 'complete',
        writeRequestGenerated: _.find(node.criteria, c => c.code === 'writeRequestGenerated')?.status === 'complete',
        discountItemsSynced: _.find(node.criteria, c => c.code === 'discountItemsSynced')?.status === 'complete'
      })) ?? [];

      return {
        pendingOrders
      };
    },
    [queryTuple.data]
  );

  return useMemo(() => ({
    ...queryTuple,
    data
  }), [queryTuple, data]);
}

